import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Card from 'common/bstCard/bstCard';

const getItemKey = (item, index) => item?.id ?? item?.scId ?? item?.reportId ?? item?.displayText ?? index;

const BstCarousel = ({ items, type, isTablet = false, viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
        {items && items.map((im, index) => <Card item={im} type={type} key={getItemKey(im, index)} viewMode={viewMode} />)}
      </Box>
    );
  }

  // For tablets: 2 cards per line (size 6)
  // For desktop: 3 cards per line (size 4)
  const gridSize = isTablet ? { xs: 12, sm: 6, md: 6 } : { xs: 12, sm: 6, md: 4, xl:3 };

  return (
    <Grid container spacing={2}>
      {items &&
        items.map((im, index) => (
          <Grid item key={getItemKey(im, index)} size={gridSize}>
            <Card item={im} type={type} viewMode={viewMode} />
          </Grid>
        ))}
    </Grid>
  );
};

export default BstCarousel;
